import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import { IntlProvider } from 'react-intl';
import { useLocale } from '../contexts/LocaleProvider';
import ResourcesHome from './resourcesPage/ResourcesHome';

const ResourcesPage: FunctionComponent = () => {
    const { locale, messages } = useLocale();

    return (
        <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
            <Box
                width="100%"
                component="main"
                sx={{
                    padding: 0,
                    flexGrow: 0,
                    p: 0,
                }}
            >
                <ResourcesHome />
            </Box>
        </IntlProvider>
    );
};

export default ResourcesPage;
